import { render } from "./MainComponent.vue?vue&type=template&id=70368f90&lang=pug"
import script from "./MainComponent.vue?vue&type=script&lang=js"
export * from "./MainComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/product-2022-dapp-front/product-2022-dapp-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__